export default __webpack_public_path__ + "static/media/s002.5d748fa1.png";